import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SYNC = [["synced", "Synced"], ["waiting", "Waiting to sync"], ["error", "Sync error"], ["review", "Needs review"], ["no_consent", "No consent"]];

const F = ({ label, value, onChange, items, testid }) => (
  <div className="space-y-1.5">
    <p className="text-xs uppercase tracking-[0.12em] text-muted-ink">{label}</p>
    <Select value={value || "all"} onValueChange={(x) => onChange(x === "all" ? "" : x)}>
      <SelectTrigger className="h-10 bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All</SelectItem>
        {items.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const VolunteerFilters = ({ filters, setFilters }) => {
  const [teams, setTeams] = useState([]);
  const [statuses, setStatuses] = useState([]);
  useEffect(() => {
    api.get("/teams").then((r) => setTeams(r.data.map((t) => [t.team_id, t.name])));
    api.get("/onboarding/options").then((r) => setStatuses(r.data.statuses.map((s) => [s, s])));
  }, []);
  const set = (k) => (v) => setFilters({ ...filters, [k]: v });
  const any = Object.values(filters).some(Boolean);
  return (
    <div className="card-soft p-5 mt-6" data-testid="volunteer-filters">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <F label="In Top 5" value={filters.recommended} onChange={set("recommended")} items={teams} testid="filter-recommended" />
        <F label="Preferred" value={filters.preferred} onChange={set("preferred")} items={[["any", "Any preference"], ["none", "No preference"], ...teams]} testid="filter-preferred" />
        <F label="Approved" value={filters.approved} onChange={set("approved")} items={[["any", "Any approved"], ["none", "Not approved"], ...teams]} testid="filter-approved" />
        <F label="Onboarding" value={filters.onboarding} onChange={set("onboarding")} items={statuses} testid="filter-onboarding" />
        <F label="Sync status" value={filters.sync} onChange={set("sync")} items={SYNC} testid="filter-sync" />
        <div className="space-y-1.5">
          <p className="text-xs uppercase tracking-[0.12em] text-muted-ink">Completed from</p>
          <Input type="date" value={filters.date_from || ""} onChange={(e) => set("date_from")(e.target.value)} className="h-10 bg-white" data-testid="filter-date-from" />
        </div>
        <div className="space-y-1.5">
          <p className="text-xs uppercase tracking-[0.12em] text-muted-ink">Completed to</p>
          <Input type="date" value={filters.date_to || ""} onChange={(e) => set("date_to")(e.target.value)} className="h-10 bg-white" data-testid="filter-date-to" />
        </div>
      </div>
      {any && <button onClick={() => setFilters({})} className="text-sm text-teal mt-4" data-testid="filter-clear-btn">Clear filters</button>}
    </div>
  );
};
